import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import dayjs from 'dayjs';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { PatientSessionCard, NoInformation, Progress, Header, Text } from '../../components';

import { patientPageWidth } from '../../constant';

import { GET_PUBLIC_OPEN_SESSIONS } from '../../services/patient';

import { alertError } from '../../redux/stateActions';

const Public = ({ history }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const [date, setDate] = useState(null);

    useEffect(() => {
        setDate(dayjs().format('YYYY-MM-DD'));
    }, []);

    /*--------------- Get Next public open meet ---------------*/
    const [publicSessions, setPublicSessions] = useState([]);

    const {
        data: getOpenSessionsData,
        loading: getOpenSessionsLoading,
        error: getOpenSessionsError,
    } = useQuery(GET_PUBLIC_OPEN_SESSIONS, {
        variables: {
            id: user.patient.id,
            date: date,
            limit: 0,
        },
        skip: _.isEmpty(user) || !date,
    });

    useEffect(() => {
        if (getOpenSessionsError) {
            dispatch(alertError(`Cannot get open session`));
        }

        if (getOpenSessionsData && !_.isEmpty(getOpenSessionsData.sessions)) {
            setPublicSessions(getOpenSessionsData.sessions);
        }
    }, [getOpenSessionsError, getOpenSessionsData]);

    const handleRedirectPublicDetail = (id) => {
        history.push(`/appointment/open/${id}`);
    };

    const handleGoBack = () => {
        history.goBack();
    };
    const handleSearch = () => {
        console.log('handleSearch');
    };

    return (
        <div
            style={{
                margin: '0 15px',
                width: '100%',
                maxWidth: patientPageWidth,
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                padding: '0 15px',
                height: '100vh',
            }}
        >
            <Header
                showGoBack1
                onClickGoBack={handleGoBack}
                onSearch={handleSearch}
                childrenContainerStyle={{ textAlign: 'center' }}
            >
                <Text $bold>Open Session</Text>
            </Header>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '15px',
                    overflowY: 'auto',
                    paddingBottom: '75px',
                }}
            >
                {getOpenSessionsLoading && <Progress />}
                {!_.isEmpty(publicSessions) ? (
                    publicSessions.map((session) => (
                        <PatientSessionCard
                            data={session}
                            key={session.id}
                            onClick={() => handleRedirectPublicDetail(session.id)}
                        />
                    ))
                ) : (
                    <NoInformation />
                )}
            </div>
        </div>
    );
};

Public.propTypes = {
    history: PropTypes.object,
};

export default Public;
